import type { Quota } from './types';

export const LOW_CREDITS_THRESHOLD = 0.2; // 20% remaining triggers "low" status

export const EMPTY_QUOTA: Quota = {
  used: 0,
  remaining: 0,
  total: 0,
};
